import React from "react"

export type ListOptions = {
  id: string
  label?: string
  Component?: React.ReactNode
}

export const ListItem: React.FC<ListOptions> = (props) => {
  const { id, label, Component } = props
  return (
    <div>
      {Component || label}
    </div>
  )
}